import React, {FC, useEffect, useState} from "react";
import {faPlus, faSave} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router";
import {useApiService} from "../../../../lib/src/api/hooks/useApiService";
import config from "../../config";
import {Autocomplete} from "../../../../lib/src/components/form/Autocomplete";
import {Task} from "../../../../lib/src/api/dto/Task";
import {getToken} from "@ventumsoftware/react-toolkit";
import {IconButton} from "../../../../lib/src/components/form/Button";
import {AddTaskModal} from "../AddTaskModal";
import {ErrorBag} from "../../../../lib/src/api/common/APIService";
import {ProjectVisit} from "@traas/lib/src/api/dto/ProjectVisit";
import {useFetchedResource} from "../../api/APIContext";
import {ModalFooter, useModal} from "@traas/lib/src/components/layout/ModalProvider";
import {ValidationError} from "@traas/lib/src/api/common/APIService";

export const LinkProjectVisitTaskModal: FC<{ visit: ProjectVisit, onFinished?: () => void }> = (props) => {
  const navigate = useNavigate();
  const { projectVisitService, taskService } = useApiService(config, getToken, navigate)
  const [selectedTask, setSelectedTask] = useState<string>('-')
  const [errors, setErrors] = useState<ErrorBag>({})
  const {resource: tasks, reload: reloadTasks} = useFetchedResource<Task[], string>(() => taskService.browseByProjectId(props.visit.projectId))
  const addTaskModal = useModal({title: "Taak toevoegen", body: <AddTaskModal projectId={props.visit.projectId} onSubmit={async () => {reloadTasks(props.visit.projectId)}} />})

  useEffect(() => {
    reloadTasks(props.visit.projectId)
  }, [props.visit]);
  
  const taskOptions: [string, string][] = [
    ['-', 'Selecteer taak'], ...(tasks ?? [])
      .map<[string, string]>(item => [item.id, item.description ?? '??'])
  ];

  const confirm = async () => {
    await projectVisitService.linkTask(props.visit.id, {task: selectedTask})
      .catch(e => {
        if (e instanceof ValidationError) {
          setErrors(old => ({...old, ...e.errors}))
      }
      throw e
    })
    props.onFinished?.()
  }
  return <>
    <div className={'min-h-72'}>
      <div className={'flex flex-row items-center'}>
        <div className={'flex flex-1 space-x-3'}>
          <Autocomplete label={'Taak'} options={taskOptions} value={selectedTask} onChange={setSelectedTask} />
        </div>
        <div className={'flex mt-6'}>
          <IconButton type={'secondary'} icon={faPlus} size={'md'} onClick={() => {
            addTaskModal.open()
          }} />
        </div>
      </div>
    </div>
    <ModalFooter text={'Opslaan'} icon={faSave} onSubmit={confirm} />
    </>
}